import styled from "styled-components";


export const Container = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 1rem 0;
  border: 1px solid ${({ color }) => color};
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  max-height: 10rem;
  overflow-y: auto;
  
  .title {
    font-size: 1rem;
    color: ${({ color }) => color};
    margin: 0;
  }
`;

export const OptionsList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  display: grid;
  gap: 0.5rem;
  grid-template-rows: 2fr;
`;

export const OptionItem = styled.li<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primaryBlue.main};
  font-size: 0.9rem;

  input[type="radio"] {
    accent-color: ${({ color }) => color};
  }

  input[type="text"] {
    border: none;
    border-bottom: 1px solid ${({ color }) => color};
  }

  input[type="text"]:focus {
    outline: none !important;
    border-bottom: 1px solid ${({ color }) => color};
  }
`;

